import state from './module-subscriber-state';
import mutations from './module-subscriber-mutations';
import actions from './module-subscriber-actions';
import getters from './module-subscriber-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
